export default __webpack_public_path__ + "upload/fact.c1ac9627.svg";